module.exports = __webpack_public_path__ + "img/Be_Berlin_Logo.ad742c36.png";